import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';

var mountNode = document.getElementById('root');
ReactDOM.render(<App name="El Galla" />, mountNode);
